// extracted by mini-css-extract-plugin
export default {"plugin_card":"PluginCard_plugin_card__PgAn+","card_title":"PluginCard_card_title__cul+I","card_desc":"PluginCard_card_desc__11VA+","disabled":"PluginCard_disabled__wEMAd"};